var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCryptoPaymentGateway(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 680 410",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrow",
    viewBox: "0 0 10 10",
    refX: 8,
    refY: 5,
    markerWidth: 6,
    markerHeight: 6,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 1L8 5L2 9",
    fill: "none",
    stroke: "context-stroke",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "imagine-text-gaps-fj34px",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 680,
    height: 410,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.716957092285156,
    y: 22.611099243164062,
    width: 120.56609344482422,
    height: 16.75001335144043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 55.69442367553711,
    width: 176.67942810058594,
    height: 29.50002670288086,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 81.69441986083984,
    width: 98.4822998046875,
    height: 29.50002670288086,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.652732849121094,
    y: 154.66664123535156,
    width: 72.69451141357422,
    height: 18.16668128967285,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.96196365356445,
    y: 171.08331298828125,
    width: 100.0760498046875,
    height: 16.277791023254395,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.8285369873047,
    y: 152.0277557373047,
    width: 26.3429012298584,
    height: 15.333345413208008,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.6388397216797,
    y: 151.66664123535156,
    width: 80.72229766845703,
    height: 18.16668128967285,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.65357971191406,
    y: 170.0277557373047,
    width: 114.69281768798828,
    height: 15.333345413208008,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.1047821044922,
    y: 182.0277557373047,
    width: 55.79041290283203,
    height: 15.333345413208008,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.61236572265625,
    y: 152.0277557373047,
    width: 40.77520751953125,
    height: 15.333345413208008,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.9899597167969,
    y: 154.66664123535156,
    width: 86.02005004882812,
    height: 18.16668128967285,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.23626708984375,
    y: 171.08331298828125,
    width: 111.52745056152344,
    height: 16.349355697631836,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.050537109375,
    y: 152.0277557373047,
    width: 31.898897171020508,
    height: 15.333345413208008,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.9906005859375,
    y: 154.66664123535156,
    width: 58.018714904785156,
    height: 18.16668128967285,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 537.5693359375,
    y: 171.08331298828125,
    width: 86.86119079589844,
    height: 16.277791023254395,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.999996185302734,
    y: 238.66664123535156,
    width: 66.01698684692383,
    height: 18.16668128967285,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.999996185302734,
    y: 258.6666564941406,
    width: 81.3716049194336,
    height: 18.16668128967285,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.999996185302734,
    y: 278.6666564941406,
    width: 116.7219009399414,
    height: 18.16668128967285,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 238.66664123535156,
    width: 102.71754455566406,
    height: 18.16668128967285,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 258.6666564941406,
    width: 109.15158081054688,
    height: 18.16668128967285,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 278.6666564941406,
    width: 129.39813232421875,
    height: 18.16668128967285,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.9999694824219,
    y: 238.66664123535156,
    width: 89.05262756347656,
    height: 18.16668128967285,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.9999694824219,
    y: 258.6666564941406,
    width: 127.73799896240234,
    height: 18.16668128967285,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.9999694824219,
    y: 278.6666564941406,
    width: 124.0708999633789,
    height: 18.16668128967285,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.51125717163086,
    y: 332.611083984375,
    width: 60.97748565673828,
    height: 16.75001335144043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.82420349121094,
    y: 332.611083984375,
    width: 54.35161209106445,
    height: 16.751771926879883,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.06484985351562,
    y: 332.611083984375,
    width: 27.87024688720703,
    height: 16.75001335144043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.0648498535156,
    y: 332.611083984375,
    width: 27.87024688720703,
    height: 16.75001335144043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.2019958496094,
    y: 332.611083984375,
    width: 67.59598159790039,
    height: 16.75001335144043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.755615234375,
    y: 332.611083984375,
    width: 34.48874282836914,
    height: 16.75001335144043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 492.8241882324219,
    y: 332.611083984375,
    width: 54.35161209106445,
    height: 16.75001335144043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 577.8241577148438,
    y: 332.611083984375,
    width: 54.35161209106445,
    height: 16.75001335144043,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 372.611083984375,
    width: 445.0126037597656,
    height: 16.751771926879883,
    fill: "black",
    rx: 2
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 680,
    height: 400,
    rx: 12,
    fill: "#0d0f1a",
    style: {
      fill: "rgb(13, 15, 26)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 80,
    x2: 680,
    y2: 80,
    stroke: "#1a1f35",
    strokeWidth: 0.5,
    mask: "url(#imagine-text-gaps-fj34px)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(26, 31, 53)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 160,
    x2: 680,
    y2: 160,
    stroke: "#1a1f35",
    strokeWidth: 0.5,
    mask: "url(#imagine-text-gaps-fj34px)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(26, 31, 53)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 240,
    x2: 680,
    y2: 240,
    stroke: "#1a1f35",
    strokeWidth: 0.5,
    mask: "url(#imagine-text-gaps-fj34px)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(26, 31, 53)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 320,
    x2: 680,
    y2: 320,
    stroke: "#1a1f35",
    strokeWidth: 0.5,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(26, 31, 53)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 0,
    x2: 170,
    y2: 400,
    stroke: "#1a1f35",
    strokeWidth: 0.5,
    mask: "url(#imagine-text-gaps-fj34px)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(26, 31, 53)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 0,
    x2: 340,
    y2: 400,
    stroke: "#1a1f35",
    strokeWidth: 0.5,
    mask: "url(#imagine-text-gaps-fj34px)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(26, 31, 53)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 510,
    y1: 0,
    x2: 510,
    y2: 400,
    stroke: "#1a1f35",
    strokeWidth: 0.5,
    mask: "url(#imagine-text-gaps-fj34px)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(26, 31, 53)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 20,
    width: 120,
    height: 22,
    rx: 4,
    fill: "#1a1f35",
    style: {
      fill: "rgb(26, 31, 53)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 84,
    y: 35,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#7b8ab8",
    fontFamily: "monospace",
    style: {
      fill: "rgb(123, 138, 184)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "EXCHANGE PLATFORM"), /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 78,
    fontSize: 22,
    fill: "#ffffff",
    fontWeight: 600,
    fontFamily: "sans-serif",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 22,
      fontWeight: 600,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "Crypto Payment"), /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 104,
    fontSize: 22,
    fill: "#7c6af7",
    fontWeight: 600,
    fontFamily: "sans-serif",
    style: {
      fill: "rgb(124, 106, 247)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 22,
      fontWeight: 600,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "Gateway"), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 148,
    width: 110,
    height: 44,
    rx: 6,
    fill: "#12153a",
    stroke: "#2a2f5a",
    strokeWidth: 0.5,
    style: {
      fill: "rgb(18, 21, 58)",
      stroke: "rgb(42, 47, 90)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 95,
    y: 168,
    textAnchor: "middle",
    fontSize: 12,
    fill: "#a0aacc",
    fontFamily: "sans-serif",
    style: {
      fill: "rgb(160, 170, 204)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Client wallet"), /*#__PURE__*/React.createElement("text", {
    x: 95,
    y: 183,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#5a6488",
    fontFamily: "sans-serif",
    style: {
      fill: "rgb(90, 100, 136)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "USDT / ETH / BTC"), /*#__PURE__*/React.createElement("line", {
    x1: 152,
    y1: 170,
    x2: 192,
    y2: 170,
    stroke: "#7c6af7",
    strokeWidth: 1.5,
    markerEnd: "url(#arrow)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(124, 106, 247)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 172,
    y: 163,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#5a4aaa",
    fontFamily: "sans-serif",
    style: {
      fill: "rgb(90, 74, 170)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "sign"), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 142,
    width: 124,
    height: 56,
    rx: 6,
    fill: "#1a1235",
    stroke: "#7c6af7",
    strokeWidth: 1,
    style: {
      fill: "rgb(26, 18, 53)",
      stroke: "rgb(124, 106, 247)",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 256,
    y: 165,
    textAnchor: "middle",
    fontSize: 12,
    fill: "#c4b8ff",
    fontWeight: 500,
    fontFamily: "sans-serif",
    style: {
      fill: "rgb(196, 184, 255)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 12,
      fontWeight: 500,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "PAY Gateway"), /*#__PURE__*/React.createElement("text", {
    x: 256,
    y: 181,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#7c6af7",
    fontFamily: "sans-serif",
    style: {
      fill: "rgb(124, 106, 247)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "validate \xB7 convert \xB7 route"), /*#__PURE__*/React.createElement("text", {
    x: 256,
    y: 193,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#5a4aaa",
    fontFamily: "sans-serif",
    style: {
      fill: "rgb(90, 74, 170)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "SIWE auth"), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 170,
    x2: 360,
    y2: 170,
    stroke: "#2dd4bf",
    strokeWidth: 1.5,
    markerEnd: "url(#arrow)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(45, 212, 191)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 163,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#1a8a7a",
    fontFamily: "sans-serif",
    style: {
      fill: "rgb(26, 138, 122)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "confirm"), /*#__PURE__*/React.createElement("rect", {
    x: 362,
    y: 148,
    width: 120,
    height: 44,
    rx: 6,
    fill: "#0d1f1a",
    stroke: "#2dd4bf",
    strokeWidth: 0.5,
    style: {
      fill: "rgb(13, 31, 26)",
      stroke: "rgb(45, 212, 191)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 422,
    y: 168,
    textAnchor: "middle",
    fontSize: 12,
    fill: "#7eeee6",
    fontFamily: "sans-serif",
    style: {
      fill: "rgb(126, 238, 230)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Smart contract"), /*#__PURE__*/React.createElement("text", {
    x: 422,
    y: 183,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#1a8a7a",
    fontFamily: "sans-serif",
    style: {
      fill: "rgb(26, 138, 122)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Polygon \xB7 BSC \xB7 TON"), /*#__PURE__*/React.createElement("line", {
    x1: 484,
    y1: 170,
    x2: 524,
    y2: 170,
    stroke: "#a0aacc",
    strokeWidth: 1.5,
    markerEnd: "url(#arrow)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(160, 170, 204)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 504,
    y: 163,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#5a6488",
    fontFamily: "sans-serif",
    style: {
      fill: "rgb(90, 100, 136)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "settle"), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 148,
    width: 110,
    height: 44,
    rx: 6,
    fill: "#12153a",
    stroke: "#2a2f5a",
    strokeWidth: 0.5,
    style: {
      fill: "rgb(18, 21, 58)",
      stroke: "rgb(42, 47, 90)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 581,
    y: 168,
    textAnchor: "middle",
    fontSize: 12,
    fill: "#a0aacc",
    fontFamily: "sans-serif",
    style: {
      fill: "rgb(160, 170, 204)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Merchant"), /*#__PURE__*/React.createElement("text", {
    x: 581,
    y: 183,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#5a6488",
    fontFamily: "sans-serif",
    style: {
      fill: "rgb(90, 100, 136)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "fiat or crypto out"), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 222,
    x2: 656,
    y2: 222,
    stroke: "#1a1f35",
    strokeWidth: 0.5,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(26, 31, 53)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 242,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#7c6af7",
    style: {
      fill: "rgb(124, 106, 247)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 252,
    fontSize: 12,
    fill: "#a0aacc",
    fontFamily: "sans-serif",
    style: {
      fill: "rgb(160, 170, 204)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "Multi-chain"), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 262,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#7c6af7",
    style: {
      fill: "rgb(124, 106, 247)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 272,
    fontSize: 12,
    fill: "#a0aacc",
    fontFamily: "sans-serif",
    style: {
      fill: "rgb(160, 170, 204)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "Non-custodial"), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 282,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#7c6af7",
    style: {
      fill: "rgb(124, 106, 247)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 292,
    fontSize: 12,
    fill: "#a0aacc",
    fontFamily: "sans-serif",
    style: {
      fill: "rgb(160, 170, 204)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "SIWE authentication"), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 242,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#2dd4bf",
    style: {
      fill: "rgb(45, 212, 191)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 256,
    y: 252,
    fontSize: 12,
    fill: "#a0aacc",
    fontFamily: "sans-serif",
    style: {
      fill: "rgb(160, 170, 204)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "Instant settlement"), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 262,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#2dd4bf",
    style: {
      fill: "rgb(45, 212, 191)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 256,
    y: 272,
    fontSize: 12,
    fill: "#a0aacc",
    fontFamily: "sans-serif",
    style: {
      fill: "rgb(160, 170, 204)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "Fiat off-ramp ready"), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 282,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#2dd4bf",
    style: {
      fill: "rgb(45, 212, 191)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 256,
    y: 292,
    fontSize: 12,
    fill: "#a0aacc",
    fontFamily: "sans-serif",
    style: {
      fill: "rgb(160, 170, 204)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "White-label deployable"), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 242,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#f59e0b",
    style: {
      fill: "rgb(245, 158, 11)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 466,
    y: 252,
    fontSize: 12,
    fill: "#a0aacc",
    fontFamily: "sans-serif",
    style: {
      fill: "rgb(160, 170, 204)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "API + webhook"), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 262,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#f59e0b",
    style: {
      fill: "rgb(245, 158, 11)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 466,
    y: 272,
    fontSize: 12,
    fill: "#a0aacc",
    fontFamily: "sans-serif",
    style: {
      fill: "rgb(160, 170, 204)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "Dashboard + reporting"), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 282,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#f59e0b",
    style: {
      fill: "rgb(245, 158, 11)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 466,
    y: 292,
    fontSize: 12,
    fill: "#a0aacc",
    fontFamily: "sans-serif",
    style: {
      fill: "rgb(160, 170, 204)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "Enterprise deployable"), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 330,
    width: 70,
    height: 22,
    rx: 4,
    fill: "#1a1235",
    style: {
      fill: "rgb(26, 18, 53)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 345,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#7c6af7",
    fontFamily: "monospace",
    style: {
      fill: "rgb(124, 106, 247)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Solidity"), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 330,
    width: 70,
    height: 22,
    rx: 4,
    fill: "#1a1235",
    style: {
      fill: "rgb(26, 18, 53)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 155,
    y: 345,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#7c6af7",
    fontFamily: "monospace",
    style: {
      fill: "rgb(124, 106, 247)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Polygon"), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 330,
    width: 50,
    height: 22,
    rx: 4,
    fill: "#1a1235",
    style: {
      fill: "rgb(26, 18, 53)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 225,
    y: 345,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#7c6af7",
    fontFamily: "monospace",
    style: {
      fill: "rgb(124, 106, 247)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "BSC"), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 330,
    width: 50,
    height: 22,
    rx: 4,
    fill: "#1a1235",
    style: {
      fill: "rgb(26, 18, 53)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 285,
    y: 345,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#7c6af7",
    fontFamily: "monospace",
    style: {
      fill: "rgb(124, 106, 247)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "TON"), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 330,
    width: 80,
    height: 22,
    rx: 4,
    fill: "#0d1f1a",
    style: {
      fill: "rgb(13, 31, 26)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 345,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#2dd4bf",
    fontFamily: "monospace",
    style: {
      fill: "rgb(45, 212, 191)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "ethers.js"), /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 330,
    width: 60,
    height: 22,
    rx: 4,
    fill: "#0d1f1a",
    style: {
      fill: "rgb(13, 31, 26)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 440,
    y: 345,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#2dd4bf",
    fontFamily: "monospace",
    style: {
      fill: "rgb(45, 212, 191)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "SIWE"), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 330,
    width: 80,
    height: 22,
    rx: 4,
    fill: "#1f1508",
    style: {
      fill: "rgb(31, 21, 8)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 345,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#f59e0b",
    fontFamily: "monospace",
    style: {
      fill: "rgb(245, 158, 11)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Node.js"), /*#__PURE__*/React.createElement("rect", {
    x: 570,
    y: 330,
    width: 70,
    height: 22,
    rx: 4,
    fill: "#1f1508",
    style: {
      fill: "rgb(31, 21, 8)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 605,
    y: 345,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#f59e0b",
    fontFamily: "monospace",
    style: {
      fill: "rgb(245, 158, 11)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Fastify"), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 385,
    fontSize: 11,
    fill: "#3a4468",
    fontFamily: "monospace",
    style: {
      fill: "rgb(58, 68, 104)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "crypto payment gateway \xB7 smart contract \xB7 enterprise \xB7 white-label"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptoPaymentGateway);
export default __webpack_public_path__ + "static/media/crypto-payment-gateway.1ec4ffb06a5aa09ff993db26d217c374.svg";
export { ForwardRef as ReactComponent };